import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { DOCUMENT_TOAST } from '../constants/toastConstant';

import Instance from './interceptor';

export const subscriberDetails = async (sorting, inputValue, filterModel) => {
  try {
    const data = {
      searchData: inputValue,
      filterModel,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
    };
    const response = await Instance.post(`${API.ORGANIZATION_DATA}`, data);
    if (response?.data?.users?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.users;
    }
    return response?.data?.users;
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
export const salesSubscriberDetails = async (
  sorting,
  inputValue,
  filterModel,
  filterValue,
  data,
  page,
) => {
  try {
    const PAGE_LIMIT = 25;
    const payload = {
      searchData: inputValue,
      filterModel,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
      page,
      limit: PAGE_LIMIT,
    };
    const response = await Instance.post(
      `${API.SALES_ORGANIZATION_DATA}`,
      payload,
    );
    if (response?.data?.users?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const invitedSubscriberDetails = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
  data,
  page,
) => {
  const PAGE_LIMIT = 25;
  const role =
    dropDownValue &&
    Object.keys(dropDownValue)?.length > 0 &&
    dropDownValue?.role?.map((c) => c.value);
  try {
    const payload = {
      searchData: inputValue,
      filterModel,
      role,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
      page,
      limit: PAGE_LIMIT,
    };
    const response = await Instance.post(`${API.INVITED_SUBSCRIBER}`, payload);
    if (response?.data?.invitedSubscriber?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.invitedSubscriber;
    }
    return response?.data?.invitedSubscriber;
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
